export const STORE_USER = 'user/store-user'
export const FAILED_TO_ADD_ACCOUNT = 'user/failed-to-add-account'
export const NO_ACCOUNT_CONNECTED = 'user/no-account-added'
